import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const PaymentModal = ({ show, onHide, appointment, onSave }) => {
  const [amount, setAmount] = useState("");

  useEffect(() => {
    if (appointment) setAmount(appointment.payment?.feePaid ?? "");
    else setAmount("");
  }, [appointment]);

  const handleSave = () => {
    const numeric = Number(amount);
    if (isNaN(numeric) || numeric <= 0) {
      return alert("Enter a valid amount");
    }
    onSave(numeric);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Record Payment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Amount Paid (Rs.)</Form.Label>
          <Form.Control
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </Form.Group>
        {/* <p className="text-muted mt-2">
          Mark appointment payment as <strong>paid</strong> if amount &gt; 0.
        </p> */}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleSave}>
          Save Payment
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PaymentModal;
